import { Box } from "@mui/material";
import React from "react";

const ImageWithTag = ({ image, title, price }) => {
  return (
    <Box className="w-1/3 inline-block relative">
      <img
        src={`${image}?w=164&h=164&fit=crop&auto=format`}
        alt={title}
        loading="lazy"
        className="rounded-lg"
      />
      {price == "Free" && (
        <div className="absolute top-0 left-0 rounded-tl-lg rounded-lg text-yellow-600 text-center text-xs overflow-hidden py-1 px-2 rounded-r-full bg-black">
          အခမဲ့
        </div>
      )}
    </Box>
  );
};

export default ImageWithTag;
